import { render } from "./HyoshoChartComponent.vue?vue&type=template&id=523e4120&ts=true"
import script from "./HyoshoChartComponent.vue?vue&type=script&lang=ts"
export * from "./HyoshoChartComponent.vue?vue&type=script&lang=ts"

import "./HyoshoChartComponent.vue?vue&type=style&index=0&id=523e4120&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__